// The stored report's ranked findings (high first, as derive_findings ordered them).

import type { Finding } from '../../services/kbEffectiveness';
import styles from '../KBEffectivenessPage.module.css';

interface Props {
  findings: Finding[];
}

export function FindingsList({ findings }: Props) {
  return (
    <section className={styles.panel} aria-label="Ranked findings">
      <div className={styles.panelHead}>
        <h2>Ranked findings</h2>
        <span className={styles.meta}>{findings.length} crossed a threshold</span>
      </div>
      {findings.length === 0 ? (
        <p className={styles.empty}>No finding crossed a threshold in this run.</p>
      ) : (
        <ol className={styles.findings}>
          {findings.map((f, i) => (
            <li key={`${f.kind}-${f.profile_id ?? 'bank'}-${i}`} className={styles.finding}>
              <span className={`${styles.severity} ${styles[`sev_${f.severity}`]}`}>{f.severity}</span>
              {f.profile_id ? <code className={styles.profileTag}>{f.profile_id}</code> : null}
              <span className={styles.findingTitle}>{f.title}</span>
              <span className={styles.findingEvidence}>{f.evidence}</span>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
